var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('x-table',{attrs:{"tableData":_vm.tableData,"tableHeaders":_vm.tableHeaders,"border":"","pageModel":_vm.pageModel,"total":_vm.total,"fetchList":_vm.fetchUser,"clickData":_vm.clickData},on:{"clickRight":_vm.clickRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }